import * as React from 'react'
import { FC } from 'react'

// Use case: prevent react-admin props from being passed into generic html elements (which tends to throw unexpected prop warnings)
export const ElementSansParentProps: FC = ({ children }) => <>{children} </>
